<template>
  <!-- 
    USAGE:
    
    1. import component na view:

    import Resume from "@/components/backoffice/resume_global/resume";
    components: {
      Resume,
    },
    
    2. No Html passe na props data_resume as chaves
    * data (Contendo o 'array de Objetos')
    * keys (As chaves dos objetos que devem ser somadas)
    * showSum (Boleano para mostrar a soma dos itens)
    * hideAlert (Ocultar alerta)

    exemplo:
    <Resume
      :data_resume="{
        data: data_resume,
        keys: ['amount', 'comission', 'prize'],
        showSum: true,
        hideAlert: true,
      }"
    />

    3. Traduza a chave que não tiver descrição ainda no metódo;
  -->
  <div class="mb-8">
    <div v-if="items.length > 0">
      <h3 v-show="!data_resume.noTitle" class="pt-4 text-center">
        {{ $t("periodSummaryTitle") }}
      </h3>
      <div v-show="this.items.length > 0" class="text-center mb-4 caption">
        {{ month ? month : $store.state.rangeUI }}
      </div>
      <v-simple-table>
        <template v-slot:default>
          <!-- <thead>
            <tr>
              <th class="text-left">Descrição</th>
              <th class="text-right">Valor</th>
            </tr>
          </thead> -->
          <tbody>
            <tr v-for="(item, i) in items" :key="`${item.name}-${i}`">
              <td>{{ translate(item.text).toUpperCase() }}</td>
              <td class="text-right">
                <span v-if="item.text == 'qtd_deposits'">
                  {{ item.value }}
                </span>
                <span
                  v-else
                  :class="
                    item.text === 'player_first_deposit'
                      ? 'grey--text'
                      : item.text === 'prize_value'
                      ? item.value == 0
                        ? 'grey--text'
                        : 'red--text'
                      : getColor(
                          item.text == 'fee_ggr_percentage'
                            ? item.value * -1
                            : item.value
                        )
                  "
                >
                  {{ $t("labelCurrency") + " " + item.value.toFixed(2) }}
                </span>
              </td>
            </tr>
            <tr v-if="data_resume.showSum">
              <td>{{ $t("sum").toUpperCase() }}</td>
              <td class="text-right">
                <strong :class="getColor(sum)">{{ sum.toFixed(2) }}</strong>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <v-alert
      text
      type="warning"
      border="left"
      class="my-4"
      v-if="alert && !data_resume.hideAlert"
    >
      {{ $t("nullData") }}
    </v-alert>
  </div>
</template>
<script>
export default {
  name: "components-backoffice-resume-global",
  props: ["data_resume", "month"],
  data: () => ({
    items: [],
    sum: 0,
    alert: false,
  }),
  watch: {
    data_resume(val) {
      this.items = [];
      //if (val.data.length < val.keys.length) return;
      this.alert = false;
      if (val.data.length < 1) {
        this.alert = true;
        return;
      }
      const data = val.data; // data (obj com os dados);
      const keys = val.keys; // array de chaves que precisam ser somadas do obj acima;

      // Função Somadora
      const reducer = (previousValue, currentValue) =>
        previousValue + currentValue;

      // 1. Criação de Objeto com os Arrays onde
      // os valores serão somados com a função reduceer
      let obj = new Object();
      keys.forEach((key) => {
        obj[key] = [];
      });

      // 2. Alimentando os Arrays do Objeto acima com os valores
      data.forEach((element) => {
        Object.entries(element).forEach(([key, value]) => {
          keys.forEach((key_resume) => {
            if (key === key_resume) {
              obj[key].push(Number(value));
            }
          });
        });
      });

      // 3. Criando o Array de Items e Somando os valores;
      keys.forEach((key) => {
        this.items.push({
          text: key,
          value: obj[key].reduce(reducer),
        });
      });

      // 4. Somando todos os Itens (this.sum)
      var arrayAllValues = [];
      this.items.forEach((item) => {
        arrayAllValues.push(item.value);
      });
      this.sum = arrayAllValues.reduce(reducer);
    },
  },
  methods: {
    translate(text) {
      const obj = {
        amount: this.$t("salesTotal"),
        value: this.$t("totalCommission"),
        comission: this.$t("totalCommission"),
        prize: this.$t("periodSummaryTotalPrizes"),
        value_sale: this.$t("salesTotal"),
        value_comission: this.$t("totalCommission"),
        sum_bet: this.$t("sales"),
        sum_comission: this.$t("sumComission"),
        sum_net_value: this.$t("profit"),
        gross_value: this.$t("grossValue"),
        agent_comission: this.$t("commissions"),
        affiliate_commission: this.$t("commissions"),
        prize_value: this.$t("prizesPaid"),
        value_ggr: "GGR",
        fee_ggr_percentage: this.$t("feeValue"),
        value_ngr: "NGR",
        commission: this.$t("totalCommission"),
        prizes_paid: this.$t("periodSummaryTotalPrizes"),
        sales: this.$t("sales"),
        bet_amount: this.$t("betAmount"),
        prize_paid: this.$t("periodSummaryPrizesPaid"),
        prize_no_paid: this.$t("periodSummaryPossibleAwards"),
        prize_to_paid: this.$t("periodSummaryPrizesToPaid"),
        commissions: this.$t("commissions"),
        player_first_deposit: this.$t("sumFirstDeposits"),
        qtd_deposits: this.$t("qtdDeposits"),
      };
      return obj[text] || text;
    },
    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
